<template>
    <div class="blog-content">
        <!-- 骨架屏 -->
        <blog-skeleton v-if="!data"/>
        <template v-else>
            <!-- 标题 -->
            <blog-header :data="data"/>
            
            <app-image class="blog-page__thumb" :src="thumbUrl" ratio="16:9"/>
            <!-- 文章内容 -->
            <blogpost :data="content"/>
            <!-- 文章底部 -->
            <blog-footer :data="data"/>
            <!-- 评论 -->
            <blog-comment :data="data"/>
        </template>
    </div>
</template>

<script>
    import Blogpost from '@components/Blogpost'
    import AppImage from '@components/AppImage'
    
    import BlogHeader from '../BlogHeader'
    import BlogFooter from '../BlogFooter'
    import BlogComment from '../BlogComment'
    import BlogSkeleton from '@assets/svg/inline.blog-skeleton.svg'
    
    import {DEFAULT_THUMB_URL} from '@config'
    
    export default {
        name: "BlogContent",
        props: {
            data: {
                type: Object,
                default: null
            }
        },
        computed: {
            content() {
                const {data} = this
                const {content} = data || {}
                return content || ''
            },
            thumbUrl() {
                const {data} = this
                const {thumbUrl} = data || {}
                return thumbUrl || DEFAULT_THUMB_URL
            }
        },
        components: {
            AppImage,
            BlogComment,
            BlogHeader,
            Blogpost,
            BlogFooter,
            BlogSkeleton
        }
    }
</script>

<style lang="scss">

</style>